// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"102":"78c05713559916f0","640":"2f0c494df74cf0ca"}[chunkId] + ".css";
};